// Module
var code = `<tree-filter
  ng-required="\$ctrl.ngRequired"
  ng-model="\$ctrl.values"
  ng-change="\$ctrl.updateModel()"
  tree-data="\$ctrl.treeData"
  options="\$ctrl.options"
  unique-selected-ids="\$ctrl.uniqueSelectedCategoryIds"
>
</tree-filter>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/filters/loan-category-filter.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;